import ConfirmSwitch from "../../microComponents/modals/ConfirmSwitch";
import React from "react";

const PalletIdProductionColumn = (status) => {


    const columns = [
        {
            className: 'hidden',
            title: 'ردیف', dataIndex: 'row', key: 'row', render: (text, row, index) => {
                return index + 1;
            },
        },

        {
            title: ' شناسه پالت',

            dataIndex: 'palletId',
            key: 'palletId',
        }, {
            title: 'محصول',
            dataIndex: 'product',
            key: 'product',
        },

        {
            title: ' تعداد در پالت',
            dataIndex: 'numberPerPallet',
            key: 'numberPerPallet'
        }, {
            title: 'بچ',
            dataIndex: 'batchNumber',
            key: 'batchNumber',
        }, {
            title: ' کارشناس QC',
            dataIndex: 'qualityControlSupervisor',
            key: 'qualityControlSupervisor',

        }, {
            title: 'سرپرست تولید',
            dataIndex: 'seriCreateBy',
            key: 'seriCreateBy',
        },

        {
            title: 'عملیات',
            dataIndex: 'palletId',
            key: 'palletId',
            render: (x, row) => {
                return <div className="redSwitch">
                    <ConfirmSwitch rowData={row} defStatus={row.cancleRequest} checkedChildren='ابطال'
                                   title='درخواست ابطال' address='Pallet/CancleRequest' id={row.palletId}
                                   des='آیا از درخواست ابطال اطمینان دارید؟'
                                   unCheckedChildren='ابطال'/>
                </div>
            }
        },


    ];
    return [columns];
};

export default PalletIdProductionColumn;